import { useMutation, useQuery } from "@tanstack/react-query";
import type { In, Out } from "@clubcore/api";
import { useClub } from "../../club";
import { useWorkspaceScope } from "../queries";

export type Camera = Out<"core_dashboard_cameras">["cameras"][number];

export function useCameras() {
  const { api, key } = useWorkspaceScope(); const { can } = useClub();
  return useQuery({ queryKey: [...key, "cameras"], queryFn: ({ signal }) => api.protect.cameras(signal), enabled: can("cameras.view"), refetchInterval: 60_000 });
}

export function useProtectSetup() {
  const { api, key, queryClient } = useWorkspaceScope(); const { can } = useClub();
  const settings = useQuery({ queryKey: [...key, "protect-settings"], queryFn: ({ signal }) => api.protect.settings(signal), enabled: can("clubs.manage") });
  const inventory = useQuery({ queryKey: [...key, "protect-inventory"], queryFn: ({ signal }) => api.protect.inventory(signal), enabled: can("clubs.manage") });
  const refresh = () => Promise.all([
    queryClient.invalidateQueries({ queryKey: [...key, "protect-settings"] }),
    queryClient.invalidateQueries({ queryKey: [...key, "protect-inventory"] }),
    queryClient.invalidateQueries({ queryKey: [...key, "cameras"] }),
  ]);
  const save = useMutation({ mutationFn: (body: In<"core_save_protect_settings">) => api.protect.saveSettings(body), onSuccess: refresh });
  const discover = useMutation({ mutationFn: () => api.protect.discover(), onSuccess: refresh });
  const publish = useMutation({ mutationFn: ({ id, published }: { id: string; published: boolean }) => api.protect.publish(id, published), onSuccess: refresh });
  return { settings, inventory, save, discover, publish };
}
